module.exports = __webpack_public_path__ + "static/image/font/pc/bmdohyeon-2@3x.ver2_0_2.jpg?faca2c94";